import { useRef } from "react";
import { useEvent, useKeyPressEvent } from "react-use";

export const useIsKeyDownRef = (key: string) => {
  const isKeyDown = useRef(false);
  useKeyPressEvent(
    key,
    () => {
      isKeyDown.current = true;
    },
    () => {
      isKeyDown.current = false;
    },
  );
  useEvent("blur", () => {
    isKeyDown.current = false;
  });
  return isKeyDown;
};
